import {useState} from 'react';
import {RiBankLine} from 'react-icons/ri';
import type {BankCardBrandProps} from './types.ts';

export function LogoBrand({logoUrl, institutionDisplayName}: BankCardBrandProps) {
    const [imageFailed, setImageFailed] = useState(false);
    const showLogo = logoUrl !== '' && !imageFailed;

    return (
        <span className="flex min-w-0 items-center gap-2.5">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-white p-1 shadow-sm">
                {showLogo ? (
                    <img
                        alt=""
                        src={logoUrl}
                        className="h-full w-full object-contain"
                        onError={() => setImageFailed(true)}
                    />
                ) : (
                    <RiBankLine className="h-5 w-5 text-gray-500" />
                )}
            </span>
            <span className="truncate text-[19px] font-bold leading-none tracking-[-0.01em]">
                {institutionDisplayName}
            </span>
        </span>
    );
}
